import Api from './Api';
import Configuracao from '../util/Configuracao';

class DividaServDesligadoApi extends Api {
  async consultarEventos () {
    try {
      const eventosUrl = Configuracao.getConfiguracao().urlConsultarEventosDividaServDesligado;
      const response = await this.fetch(eventosUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarTipos () {
    try {
      const tiposUrl = Configuracao.getConfiguracao().urlConsultarTiposDividaServDesligado;
      const response = await this.fetch(tiposUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarServidoresDesligados () {
    try {
      const urlConsultarServidoresDesligados = Configuracao.getConfiguracao().urlConsultarServidoresDesligados;
      const response = await this.fetch(urlConsultarServidoresDesligados);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarDividas (numMatricula, codEvento, codTipo, dataInicial, dataFinal, apenasSemBaixa) {
    try {
      const dividaUrl = Configuracao.getConfiguracao().urlConsultarDividasServDesligado +
      numMatricula + '/' +
      codEvento + '/' +
      codTipo + '/' +
      dataInicial + '/' +
      dataFinal + '/' + 
      apenasSemBaixa;
      const response = await this.fetch(dividaUrl, 'post');
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async incluirDivida (divida) {
    try {
      const urlIncluirDivida = Configuracao.getConfiguracao().urlIncluirDivida;
      const response = await this.fetch(urlIncluirDivida, 'put', divida);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarDivida (divida) {
    try {
      const urlAlterarDivida = Configuracao.getConfiguracao().urlAlterarDivida;
      const response = await this.fetch(urlAlterarDivida, 'put', divida);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirDivida (numDivida) {
    try {
      const urlExcluirDivida = Configuracao.getConfiguracao().urlExcluirDivida + numDivida;
      const response = await this.fetch(urlExcluirDivida, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async cancelarDivida (numDivida, motivoCancelamento) {
    try {
      const urlCancelarDivida = Configuracao.getConfiguracao().urlCancelarDivida + numDivida + '/' + motivoCancelamento;
      const response = await this.fetch(urlCancelarDivida, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async desfazerCancelamentoDivida (numDivida) {
    try {
      const urlDesfazerCancelamentoDivida = Configuracao.getConfiguracao().urlDesfazerCancelamentoDivida + numDivida;
      const response = await this.fetch(urlDesfazerCancelamentoDivida, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async validarDivida (divida) {
    try {
      const urlValidarDivida = Configuracao.getConfiguracao().urlValidarDivida;
      const response = await this.fetch(urlValidarDivida, 'put', divida);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async baixarAutomaticamente (divida) {
    try {
      const urlBaixarAutomaticamente = Configuracao.getConfiguracao().urlBaixarAutomaticamente;
      const response = await this.fetch(urlBaixarAutomaticamente, 'put', divida);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async compensarCredito (divida) {
    try {
      const urlCompensarCredito = Configuracao.getConfiguracao().urlCompensarCredito;
      const response = await this.fetch(urlCompensarCredito, 'put', divida);
      return response;
    } catch (error) {
      console.error(error);
    }
  }  
}
export default DividaServDesligadoApi;
